<template>
  <br/>
  <div class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <label for="search" class="form-label me-2 mt-2">Search</label>
        <input id="search" class="form-control" placeholder="Name, slug, email or description" v-model="keyword" @input="searchKeyword"/>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <label for="per-page" class="form-label me-2 mt-2">Per page</label>
        <select id="per-page" class="form-control" v-model="perPage" @change="perPageFilter(perPage)">
          <option :value="10">10</option>
          <option :value="20">20</option>
          <option :value="50">50</option>
        </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <label for="country" class="form-label me-2 mt-2">Country</label>
        <select id="country" class="form-control" v-model="selectedCountry" @change="changeCountry(selectedCountry)">
          <option value="" :value="selectedCountry">All</option>
          <option v-for="country in countries" :value="country.country">{{country.country}}</option>
        </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
        <label for="status" class="form-label me-2 mt-2">Status</label>
        <select id="status" class="form-control" v-model="status" @change="changeStatus(status)">
          <option value="" :value="status">All</option>
          <option v-for="channelStatus in channelStatuses" :value="channelStatus.value">{{ channelStatus.name }}</option>
        </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="category" class="form-label me-2 mt-2">Content category</label>
      <select class="form-control" id="category" v-model="category" @change="changeCategory(category)">
        <option value="0" :value="category">
          All
        </option>
        <option v-for="contentCategory in contentCategories" :value="contentCategory.id">
          {{contentCategory.name}}
        </option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="adult" class="form-label me-2 mt-2">Adult content</label>
      <select class="form-control" id="adult" v-model="adult" @change="changeAdult(adult)">
        <option value="" :value="adult">All</option>
        <option value="true" :value="adult">Yes</option>
        <option value="false" :value="adult">No</option>
      </select>
    </div>
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <label for="stripe-action-required" class="form-label me-2 mt-2">Stripe requirements</label>
      <select
        id="stripe-action-required"
        v-model="stripeActionRequired"
        class="form-control"
        @change="changeStripeActionRequired"
      >
        <option value="">All</option>
        <option value="true">Stripe action required</option>
      </select>
    </div>
  </div>

  <div style="padding:5px" class="row">
    <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
      <button 
        type="button" 
        class="btn btn-success text-white"
        aria-label="Export filtered creators as CSV"
        :disabled="disableExport"
        @click="confirmExport()">
        <span v-if="!disableExport">Export CSV</span>
        <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
      </button>
    </div>
  </div>

  <div class="table-responsive">
    <div class="alert alert-success" role="alert" v-if="success">
      {{ success}}
    </div>
    <div class="alert alert-danger" role="alert" v-if="errorConfirm">
      {{ errorConfirm}}
    </div>
    <table class="table">
      <thead>
      <tr>
        <th scope="col"># ID</th>
        <th scope="col">Creator name, slug</th>
        <th scope="col">Email</th>
        <th scope="col">Country</th>
        <th scope="col">Status</th>
        <th scope="col">iDenfy Verification Status</th>
        <th scope="col">Name and surname (IPay)</th>
        <th scope="col">Tax Id (IPay)</th>
        <th scope="col">Merchant ID (IPay)</th>
        <th scope="col">Registration date (IPay)</th>
        <th scope="col">Registration status (IPay)</th>
        <th scope="col">Registered at</th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-if="loading">
        <td colspan="13" class="text-center">Loading...</td>
      </tr>
      <tr v-else-if="channels.length === 0">
        <td colspan="13" class="text-center">No creators</td>
      </tr>
      <template v-else>
      <template v-for="channel in channels" :key="channel.id">
      <tr>
        <th scope="row">{{channel.id}}</th>
        <td>
          <img :src="channel.profile_picture" alt="No photo" class="profile-photo"/>
          <p>{{channel.name}}</p>
          <a :href="channel.link">{{channel.slug}}</a>
        </td>
        <td>{{channel.email}}</td>
        <td>{{channel.country}}</td>
        <td>
          <span v-if="channel.status === 'awaiting_confirmation'" class="badge badge-info">
            <font-awesome-icon icon="fa-solid fa-rotate" />
            {{ channel.status_name }}
          </span>
          <span v-else-if="channel.status === 'OK'" class="badge badge-success">
            <font-awesome-icon icon="fas fa-check-circle"/>
            {{ channel.status_name }}
          </span>
          <span v-else-if="channel.status === 'stripe_confirmed_not_published'" class="badge badge-info">
            <font-awesome-icon icon="fa-solid fa-rotate"/>
            Stripe confirmed not published
          </span>
          <span v-else-if="channel.status === 'pending_check'" class="badge badge-info">
            <font-awesome-icon icon="fa-solid fa-rotate"/>
            {{ channel.status_name }}
          </span>
          <span v-else-if="channel.status === 'denied'" class="badge badge-danger">
            <font-awesome-icon icon="fa-solid fa-circle-xmark"/>
            {{ channel.status_name }}
          </span>
          <span v-else-if="channel.status === 'ipay_confirmed_not_published'" class="badge badge-info">
            <font-awesome-icon icon="fa-solid fa-circle-xmark"/>
            IPay confirmed not published
          </span>
          <span v-else class="badge badge-secondary">
            {{ channel.status_name }}
          </span>
          <br/>
          <span v-if="channel.frozen">
            <font-awesome-icon icon="fa-solid fa-circle-xmark"/>
            Restricted
          </span>
          <br v-if="channel.is_pause_supported"/>
          <span v-if="channel.is_pause_supported && channel.paused_at" class="badge bg-warning text-dark">
            Payments paused
          </span>
          <span v-else-if="channel.is_pause_supported" class="badge bg-success">
            Payments active
          </span>
          <div v-if="channel.stripe_requirements?.action_required" class="mt-2">
            <button
              type="button"
              class="badge badge-warning text-dark border-0 px-2 py-1"
              :aria-expanded="expandedStripeChannelId === channel.id"
              :aria-controls="`stripe-requirements-${channel.id}`"
              :aria-label="`${expandedStripeChannelId === channel.id ? 'Collapse' : 'Expand'} Stripe actions required for ${channel.name}`"
              @click="toggleStripeRequirements(channel.id)"
            >
              {{ stripeActionLabel(channel) }}
            </button>
          </div>
        </td>
        <td>
          <span
            v-if="channel.idenfy_status === 0"
            class="badge badge-warning"
            role="button"
            tabindex="0"
            style="cursor: pointer;"
            @click="openModal(channel.idenfy_status, channel.id)"
            @keydown.enter.prevent="openModal(channel.idenfy_status, channel.id)"
            @keydown.space.prevent="openModal(channel.idenfy_status, channel.id)">
            Not verified
          </span>
          <span
            v-else-if="channel.idenfy_status === 1"
            class="badge badge-info"
            role="button"
            tabindex="0"
            style="cursor: pointer;"
            @click="openModal(channel.idenfy_status, channel.id)"
            @keydown.enter.prevent="openModal(channel.idenfy_status, channel.id)"
            @keydown.space.prevent="openModal(channel.idenfy_status, channel.id)">
            Verification required
          </span>
          <span
            v-else-if="channel.idenfy_status === 2"
            class="badge badge-success"
            role="button"
            tabindex="0"
            style="cursor: pointer;"
            @click="openModal(channel.idenfy_status, channel.id)"
            @keydown.enter.prevent="openModal(channel.idenfy_status, channel.id)"
            @keydown.space.prevent="openModal(channel.idenfy_status, channel.id)">
            Verified
          </span>
          <span
            v-else-if="channel.idenfy_status === 3"
            class="badge badge-danger"
            role="button"
            tabindex="0"
            style="cursor: pointer;"
            @click="openModal(channel.idenfy_status, channel.id)"
            @keydown.enter.prevent="openModal(channel.idenfy_status, channel.id)"
            @keydown.space.prevent="openModal(channel.idenfy_status, channel.id)">
            Failed
          </span>
          <span
            v-else-if="channel.idenfy_status === 4"
            class="badge badge-danger"
            role="button"
            tabindex="0"
            style="cursor: pointer;"
            @click="openModal(channel.idenfy_status, channel.id)"
            @keydown.enter.prevent="openModal(channel.idenfy_status, channel.id)"
            @keydown.space.prevent="openModal(channel.idenfy_status, channel.id)">
            System error
          </span>
        </td>
        <td>{{ channel.ipay_name_surname }}</td>
        <td>{{ channel.tax_id }}</td>
        <td>{{ channel.sub_merchant_id }}</td>
        <td>{{ channel.ipay_registration_date }}</td>
        <td>{{ channel.ipay_registration_status }}</td>
        <td>{{channel.created_at}}</td>
        <td>
          <div class="btn-group-sm d-flex gap-3" role="group">
            <router-link :to="{name: 'SingleChannel', params: {id: channel.id}}" class="btn btn-info">View</router-link>
            <router-link :to="{name: 'EditChannel', params: {id: channel.id}}" class="btn btn-warning">Edit</router-link>
            <button v-if="channel.status === 'pending_check' || channel.status === 'denied'" type="button" class="btn btn-success" :disabled="disableConfirm"
                    @click="confirmChannel(channel.id, channel.name)">
              <span v-if="!disableConfirm">Confirm</span>
              <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
            </button>
            <button v-if="channel.status === 'pending_check'" type="button" class="btn btn-danger" :disabled="disableDeny"
                    @click="denyChannel(channel.id, channel.name)">
              <span v-if="!disableDeny">Deny</span>
              <span v-else><font-awesome-icon icon="fa-solid fa-sync" spin/></span>
            </button>
          </div>
        </td>
      </tr>
      <tr
        v-if="expandedStripeChannelId === channel.id"
        :id="`stripe-requirements-${channel.id}`"
        class="table-active"
      >
        <td colspan="13">
          <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
            <div>
              <h6 class="mb-1">Stripe actions required</h6>
              <div v-if="channel.stripe_requirements.due_at" class="small">
                <strong>Due date:</strong> {{ formatDateTime(channel.stripe_requirements.due_at) }}
              </div>
              <div v-if="channel.stripe_requirements.disabled_reason" class="small">
                <strong>Disabled reason:</strong>
                <code class="text-break">{{ channel.stripe_requirements.disabled_reason }}</code>
              </div>
            </div>
            <span :class="channel.stripe_requirements.overdue ? 'badge badge-danger stripe-status-badge' : 'badge badge-success stripe-status-badge'">
              {{ channel.stripe_requirements.overdue ? 'Overdue' : 'Not overdue' }}
            </span>
          </div>

          <ul v-if="stripeRequirementItems(channel).length > 0" class="list-group list-group-flush mt-2">
            <li
              v-for="(requirement, index) in stripeRequirementItems(channel)"
              :key="`${requirement.requirement}-${requirement.error_code || 'no-error'}-${index}`"
              class="list-group-item bg-transparent px-0 py-2"
            >
              <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
                <div class="small">
                  <div class="fw-bold">{{ formatStripeRequirementLabel(requirement.requirement) }}</div>
                  <div>
                    <strong>Stripe field:</strong>
                    <code class="text-break">{{ requirement.requirement }}</code>
                  </div>
                  <div v-if="requirement.error_code">
                    <strong>Error code:</strong>
                    <code class="text-break">{{ requirement.error_code }}</code>
                  </div>
                  <div v-if="requirement.reason">
                    <strong>Reason:</strong> {{ requirement.reason }}
                  </div>
                </div>
                <span :class="requirement.overdue ? 'badge badge-danger stripe-status-badge' : 'badge badge-success stripe-status-badge'">
                  {{ requirement.overdue ? 'Overdue' : 'Not overdue' }}
                </span>
              </div>
            </li>
          </ul>
          <p v-else class="small text-muted mb-0 mt-2">No specific Stripe requirements were provided.</p>
        </td>
      </tr>
      </template>
      </template>
      </tbody>
    </table>
    <div class="d-flex justify-content-between" v-if="totalRecords >= 1">
      <div>
        <div class="p-2">
          <p>Total creators: {{ totalRecords }}</p>
        </div>
      </div>
      <div>
        <div class="p-2">
          <nav v-if="totalPages >= 1" aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item" :class="{disabled: currentPage - 1 < 1}">
                <a @click="paginate(currentPage - 1)" class="page-link">Previous</a>
              </li>
              <li class="page-item" :class="{active: 1 === currentPage}">
                <a @click="paginate(1)" class="page-link" :class="{'not-clickable': currentPage === 1}">1</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage - 2 > 1">
                <a @click="paginate(currentPage - 2)" class="page-link">{{ currentPage - 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage - 1 > 1">
                <a @click="paginate(currentPage - 1)" class="page-link">{{ currentPage - 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage !== 1"  :class="{active: currentPage}">
                <a @click="paginate(currentPage)" class="page-link" :class="{'not-clickable': currentPage}">{{currentPage }}</a>
              </li>
              <li class="page-item" v-if="currentPage + 1 <= totalPages">
                <a @click="paginate(currentPage + 1)" class="page-link">{{ currentPage + 1}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 <= totalPages">
                <a @click="paginate(currentPage + 2)" class="page-link">{{ currentPage + 2}}</a>
              </li>
              <li class="page-item" v-if="currentPage + 2 < totalPages">
                <a href="#" class="page-link">...</a>
              </li>
              <li class="page-item" v-if="currentPage !== totalPages && currentPage + 2 < totalPages" :class="{active: totalPages === currentPage}">
                <a @click="paginate(totalPages)" class="page-link" :class="{'not-clickable': totalPages === currentPage}">{{totalPages }}</a>
              </li>
              <li class="page-item" :class="{disabled: currentPage + 1 > totalPages}">
                <a @click="paginate(currentPage + 1)" class="page-link">Next</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>

</template>


<script>
import axios from 'axios';
import _debounce from "lodash/debounce";
import Swal from "sweetalert2";
import idenfyVerificationMixin from "@/mixins/idenfyVerificationMixin";

export default {
  mixins: [idenfyVerificationMixin],

  data() {
    return {
      loading: true,
      disableExport: false,
      channels: [],
      countries: [],
      channelStatuses: [],
      errorConfirm: '',
      selectedCountry: '',
      status: '',
      category: 0,
      adult: '',
      stripeActionRequired: '',
      expandedStripeChannelId: null,
      contentCategories: [],
      success: '',
      keyword: '',
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      perPage: 20,
      disableConfirm: false,
      disableDeny: false,
      channelRequestId: 0,
    }
  },

  mounted() {
    this.status = this.$route.query.status ?? '';
    this.success = this.$route.query.channel_deleted ? 'Creator and their subscriptions were deleted successfully' : '';

    const errors = history.state?.errorConfirm; 
  
    if (errors && errors.length > 0) {
      this.errorConfirm = errors; 
    }

    this.fetchContentCategories();
    this.getCountries();
    this.getChannels(1);
    this.getChannelStatuses();
  },

  watch: {
    '$route.query.status'(newStatus) {
      this.status = newStatus ?? '';
      this.currentPage = 1;
      this.getChannels(1);
    },
  },

  beforeUnmount() {
    this.debounceGetChannels.cancel();
  },

  methods: {
    getCountries() {
      this.loading = true;
      axios.get(`/admin/channel/countries`).then(response => {
        this.countries = response.data.countries;
      })
          .catch(error => {
            console.log(error);
          });
    },
    buildListParams(page) {
      const params = {
        page,
        per_page: this.perPage,
        country: this.selectedCountry,
        status: this.status,
        category: this.category,
        adult: this.adult,
        keyword: this.keyword,
      };

      if (this.stripeActionRequired === 'true') {
        params.stripe_action_required = true;
      }

      return params;
    },
    debounceGetChannels: _debounce(async function (page, requestId) {
      try {
        const response = await axios.get('/admin/channels', {
          params: this.buildListParams(page),
        });

        if (requestId !== this.channelRequestId) {
          return;
        }

        const payload = response.data || {};
        const totalPages = Number(payload.totalPages || 0);

        if (page > totalPages && totalPages >= 1) {
          this.currentPage = totalPages;
          this.getChannels(totalPages);
          return;
        }

        this.channels = Array.isArray(payload.data) ? payload.data : [];
        this.currentPage = Number(payload.pageNumber || page);
        this.totalPages = totalPages;
        this.totalRecords = Number(payload.totalRecords || 0);
        this.loading = false;
      } catch (error) {
        if (requestId !== this.channelRequestId) {
          return;
        }

        this.channels = [];
        this.totalPages = 0;
        this.totalRecords = 0;
        this.loading = false;
        console.log(error);
        this.$toast.error('Failed to load creators.');
      }
    }, 500),
    getChannels(page = this.currentPage) {
      this.loading = true;
      this.expandedStripeChannelId = null;
      const requestId = ++this.channelRequestId;
      this.debounceGetChannels(page, requestId);
    },
    reloadFirstPage() {
      this.currentPage = 1;
      this.getChannels(1);
    },
    changeCountry(country) {
      this.selectedCountry = country;
      this.reloadFirstPage();
    },
    changeStatus(status) {
      this.status = status;
      this.reloadFirstPage();
    },
    changeCategory(category) {
      this.category = category;
      this.reloadFirstPage();
    },
    changeAdult(adult) {
      this.adult = adult;
      this.reloadFirstPage();
    },
    changeStripeActionRequired() {
      this.reloadFirstPage();
    },
    searchKeyword() {
      this.reloadFirstPage();
    },
    perPageFilter(perPage) {
      this.perPage = perPage;
      this.reloadFirstPage();
    },
    paginate(page) {
      this.currentPage = page;
      this.getChannels(page);
    },
    toggleStripeRequirements(channelId) {
      this.expandedStripeChannelId = this.expandedStripeChannelId === channelId ? null : channelId;
    },
    stripeActionLabel(channel) {
      const count = Number(channel.stripe_requirements?.outstanding_count || 0);
      return count > 1 ? `Stripe action required (${count})` : 'Stripe action required';
    },
    stripeRequirementItems(channel) {
      const requirements = channel.stripe_requirements?.requirements;
      return Array.isArray(requirements) ? requirements : [];
    },
    formatStripeRequirementLabel(requirement) {
      if (!requirement || typeof requirement !== 'string') {
        return 'Unknown requirement';
      }

      const label = requirement.replace(/[._]+/g, ' ').trim();
      return label ? label.charAt(0).toUpperCase() + label.slice(1) : 'Unknown requirement';
    },
    formatDateTime(value) {
      if (!value) {
        return '-';
      }

      const date = new Date(String(value).replace(' ', 'T'));
      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      }).format(date);
    },
    fetchContentCategories() {
      axios.get(`/admin/content-categories`)
          .then(response => {
            const payload = response.data;
            if (Array.isArray(payload)) {
              this.contentCategories = payload;
            } else if (payload && Array.isArray(payload.data)) {
              this.contentCategories = payload.data;
            } else {
              this.contentCategories = [];
            }
          })
          .catch(error => {
            console.log(error);
          });
    },
    async confirmChannel(channel, name) {
      const confirmed = await Swal.fire({
        title: 'Confirmation',
        text: `Are you sure you want to confirm this creator ${name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });
      if (confirmed.isConfirmed) {
        this.success = '';
        this.error = '';
        this.reason = '';
        this.disableConfirm = true;
        await axios.put(`admin/channel/confirm/${channel}`)
            .then(response => {
              this.success = response.data.message;
              this.disableConfirm = false;
              this.getChannels(this.currentPage);
              window.dispatchEvent(new Event('pending-channel-count-changed'));
              setTimeout(() => this.success = '', 60000);
            })
            .catch(error => {
              if (error.response.status === 422) {
                this.errorConfirm = error.response.data.message;
                this.disableConfirm = false;
                setTimeout(() => this.error = '', 60000);
              }
            })
      }
    },
    async denyChannel(channel, name) {
      const confirmed = await Swal.fire({
        title: 'Confirmation',
        text: `Are you sure you want to perform this operation ${name}?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, proceed',
        cancelButtonText: 'Cancel'
      });
      if (confirmed.isConfirmed) {
        this.success = '';
        this.disableDeny = true;
        axios.put(`admin/channel/deny/${channel}`)
            .then(response => {
              this.success = response.data.message;
              this.disableDeny = false;
              this.getChannels(this.currentPage);
              window.dispatchEvent(new Event('pending-channel-count-changed'));
              setTimeout(() => this.success = '', 60000);
            })
            .catch(error => {
              this.disableDeny = false;
            })
      }
    },
    confirmExport() {
      Swal.fire({
        title: "Do you want to export filtered creators ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Export",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          this.exportChannels();
        } else if (result.isDenied) {

        }
      });
    },

      exportChannels() {
        this.disableExport = true;
        const params = new URLSearchParams({
          keyword: this.keyword,
          country: this.selectedCountry,
          status: this.status,
          category: this.category,
          adult: this.adult,
        });

        if (this.stripeActionRequired === 'true') {
          params.set('stripe_action_required', 'true');
        }

        axios.get(`/admin/export/channels?${params.toString()}`, {
          responseType: 'blob'
        })
        .then(response => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const now = new Date();
          const readableTime = now.toISOString().replace(/[:.]/g, '_').replace('T', '_').split('Z')[0];
          const uniqueFileName = `creators_${readableTime}.csv`;
          const link = document.createElement('a');

        link.href = URL.createObjectURL(blob);
        link.download = uniqueFileName;
        link.click();

          URL.revokeObjectURL(link.href);
          this.disableExport = false;
          this.$toast.success('Creators exported successfully!');
        })
        .catch(error => {
          console.error('Error downloading file:', error);
          this.$toast.error('Failed to export creators. Please try again.');
          this.disableExport = false;
        });
      },

    onIdenfySuccess() {
      this.getChannels(this.currentPage);
    },

    getChannelStatuses() {
      axios.get(`admin/channel/statuses`)
          .then(response => {
            this.channelStatuses = response.data.status;
          })
          .catch(error => {
            this.error = 'Failed to get channel statuses';
          })
    }
  }
}
</script>

<style scoped>
.stripe-status-badge {
  color: #111 !important;
}
</style>
